declare namespace $ {

	type $mol_plot_group__title_shm_hitalama_chart_line_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['item_name'] >
		,
		ReturnType< $mol_plot_group['title'] >
	>
	type $mol_plot_group__series_y_shm_hitalama_chart_line_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['series_y'] >
		,
		ReturnType< $mol_plot_group['series_y'] >
	>
	type $mol_plot_group__graphs_shm_hitalama_chart_line_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_group['graphs'] >
	>
	type $mol_plot_mark_hor__labels_shm_hitalama_chart_line_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['labels'] >
		,
		ReturnType< $mol_plot_mark_hor['labels'] >
	>
	type $mol_plot_mark_cross__labels_shm_hitalama_chart_line_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['labels'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_shm_hitalama_chart_line_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $shm_hitalama_chart_line_pane__gap_left_shm_hitalama_chart_line_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['gap_left'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['gap_left'] >
	>
	type $shm_hitalama_chart_line_pane__gap_right_shm_hitalama_chart_line_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['gap_right'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['gap_right'] >
	>
	type $shm_hitalama_chart_line_pane__gap_bottom_shm_hitalama_chart_line_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['gap_bottom'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['gap_bottom'] >
	>
	type $shm_hitalama_chart_line_pane__gap_top_shm_hitalama_chart_line_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['gap_top'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['gap_top'] >
	>
	type $shm_hitalama_chart_line_pane__graphs_shm_hitalama_chart_line_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['graphs'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['graphs'] >
	>
	type $shm_hitalama_chart_line_pane__hue_base_shm_hitalama_chart_line_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['hue_base'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['hue_base'] >
	>
	type $shm_hitalama_chart_line_pane__hue_shift_shm_hitalama_chart_line_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line['hue_shift'] >
		,
		ReturnType< $shm_hitalama_chart_line_pane['hue_shift'] >
	>
	export class $shm_hitalama_chart_line extends $mol_chart {
		graphs_colored( ): ReturnType< ReturnType< $shm_hitalama_chart_line['Plot'] >['graphs_colored'] >
		item_name( id: any): string
		series_y( id: any): readonly(any)[]
		Line( id: any): $mol_plot_line
		Dot( id: any): $mol_plot_dot
		Item( id: any): $mol_plot_group
		items( ): readonly(any)[]
		Vert_ruler( ): $mol_plot_ruler_vert
		Marker_hor( ): $mol_plot_mark_hor
		dots( ): readonly(any)[]
		Marker_cross( ): $mol_plot_mark_cross
		names( ): readonly(any)[]
		labels( ): readonly(string)[]
		Plot( ): $shm_hitalama_chart_line_pane
		graphs( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=line.view.tree.d.ts.map